<template>
  <div style="margin-left:-17px;margin-top:32px" id="current-data">
    <div class="row sqs-row">
      <div class="col sqs-col-12 span-12">

        <!-- <div class="sqs-block html-block sqs-block-html count-title-block" data-block-type="2">
          <div class="sqs-block-content">
            <h1>Data for the {{ videoYear }} Mystic River Herring Run</h1>
          </div>
        </div> -->

        <!-- ACTIVITY TRACKER -->
        <div class="sqs-block html-block sqs-block-html count-title-block" data-block-type="2">
          <div class="sqs-block-content">
            <h1 class="count-title">Today's Activity</h1>
            <p class="small-text">Each bubble represents one video count from today. The bubble is placed at the time when the video was counted (<i>not</i> when the video was recorded). The size of the bubble indicates how many fish were counted in that video. Hover your mouse over the bubbles to see more information, or click and drag to zoom in.</p>
          </div>
        </div>
        <div class="row sqs-row">
          <div class="col sqs-col-2 span-2">
            <div class="sqs-block html-block sqs-block-html" data-block-type="2">
              <div class="sqs-block-content">
                <div class="odometer-wrapper" style="padding-top:30px">
                  <div class="text-align-center odometer-value">
                    <span id="odometer-activity-total" class="odometer">0</span>
                  </div>
                  <p class="text-align-center odometer-label">Videos Counted Today</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col sqs-col-7 span-7">
            <div class="sqs-block image-block sqs-block-image" data-block-type="5">
              <div class="sqs-block-content">
                <div id="chart-activity"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- ESTIMATED RUN -->
        <div class="sqs-block html-block sqs-block-html count-title-block" data-block-type="2">
          <div class="sqs-block-content">
            <h1 class="count-title">Total Estimated Fish Run</h1>
            <p class="small-text">Each bar shows our current estimate of the total number of fish migrating each day. These totals are updated in real-time using a statistical model that estimates how many fish migrate <em>over the entire day</em> based the individual counts of videos recorded on that day. The error bars represent our uncertainty in the daily total (95% confidence interval).</p>
          </div>
        </div>
        <div class="row sqs-row">
          <div class="col sqs-col-2 span-2">
            <div class="sqs-block html-block sqs-block-html" data-block-type="2">
              <div class="sqs-block-content">
                <div class="odometer-wrapper" style="padding-top:70px">
                  <div class="text-align-center odometer-value">
                    <span id="odometer-run-total" class="odometer">0</span>
                  </div>
                  <div class="text-align-center odometer-value-small">
                    +/- <span id="odometer-run-range" class="odometer">0</span>
                  </div>
                  <p class="text-align-center odometer-label">Total Estimated Fish Run</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col sqs-col-7 span-7">
            <div class="sqs-block image-block sqs-block-image" data-block-type="5">
              <div class="sqs-block-content">
                <div id="chart-run"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- WATER QUALITY -->
        <!-- <div class="sqs-block html-block sqs-block-html count-title-block" data-block-type="2">
          <div class="sqs-block-content">
            <h1 class="count-title">Temperature and Water Quality</h1>
            <p class="small-text">This chart shows temperature and water quality data measured at the dam in real time. Select a variable from the drop down menu. You can also click and drag to zoom in on a specific time period.</p>
          </div>
        </div>
        <div class="row sqs-row">
          <div class="col sqs-col-2 span-2">
            <div class="sqs-block html-block sqs-block-html" data-block-type="2">
              <div class="sqs-block-content">
                <div class="select-label">Select Variable</div>
              </div>
            </div>
          </div>
          <div class="col sqs-col-7 span-7">
            <div class="sqs-block image-block sqs-block-image" data-block-type="5">
              <div class="sqs-block-content">
                <select v-model="selectedVariable">
                  <option v-for="variable in variables" :value="variable.id" :key="variable.id">
                    {{ variable.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row sqs-row">
          <div class="col sqs-col-2 span-2">
            <div class="sqs-block html-block sqs-block-html" data-block-type="2">
              <div class="sqs-block-content" style="padding-top:10px">
                <p v-if="selectedVariable === 'temperature_degc'" class="text-align-left small-text" style="color:black">
                  Water temperature is the primary factor that determines when the herring begin their annual migration ustream. In most years, herring wait until temperatures rise above 13 deg C (55 deg F) to begin migrating.
                </p>
                <p v-if="selectedVariable === 'specificconductance_us_cm'" class="text-align-left small-text" style="color:black">
                  Specific conductivity is similar to salinity and represents how salty the water is. This tends to change rapidly when it rains and the river is flushed out by fresh water.
                </p>
                <p v-if="selectedVariable === 'turbidity_ntu'" class="text-align-left small-text" style="color:black">
                  Turbidity reflects how cloudy the water is. This tends to be higher during large rain storms due to runoff that carries particles from the land and into the river.
                </p>
                <p v-if="selectedVariable === 'odo_mg_l'" class="text-align-left small-text" style="color:black">
                  Dissolved oxygen is important for the health and survival of fish. When this falls below 5 mg/L, fish can become stressed and ultimately die due to lack of oxygen.
                </p>
                <p v-if="selectedVariable === 'chlorophyll_rfu'" class="text-align-left small-text" style="color:black">
                  Chlorophyll reflects the amount of plant matter (primarily algae) in the water. This tends to increase over the summer as the algae grow.
                </p>
              </div>
            </div>
          </div>
          <div class="col sqs-col-7 span-7">
            <div class="sqs-block image-block sqs-block-image" data-block-type="5">
              <div class="sqs-block-content">
                <div id="chart-sensor"></div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- # FISH COUNTED -->
        <div class="sqs-block html-block sqs-block-html count-title-block" data-block-type="2">
          <div class="sqs-block-content">
            <h1 class="count-title">Number of Fish Counted</h1>
            <p class="small-text">Each bar shows the total number of fish that have been counted for each day (so far). These totals will increase as more videos are watched. Note that these totals tend to be much less than those in the chart above, which uses these counts to estimate the total number of fish passing over the entire day, not just during the videos that have been counted so far.</p>
          </div>
        </div>
        <div class="row sqs-row">
          <div class="col sqs-col-2 span-2">
            <div class="sqs-block html-block sqs-block-html" data-block-type="2">
              <div class="sqs-block-content">
                <div class="odometer-wrapper" style="padding-top:70px">
                  <div class="text-align-center odometer-value">
                    <span id="odometer-fish-total" class="odometer">0</span>
                  </div>
                  <p class="text-align-center odometer-label">Total Fish Counted</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col sqs-col-7 span-7">
            <div class="sqs-block image-block sqs-block-image" data-block-type="5">
              <div class="sqs-block-content">
                <div id="chart-fish"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- VIDEO STATUS -->
        <div class="sqs-block html-block sqs-block-html count-title-block" data-block-type="2">
          <div class="sqs-block-content">
            <h1 class="count-title">Number of Videos</h1>
            <p class="small-text">Each bar shows how many videos were recorded each day, plus how many of those have been counted and how many remain to be counted. The number of recorded videos depends on how active the fish were on that day, but also whether the camera was properly configured to only record when it detected fish and not other things floating by.</p>
          </div>
        </div>
        <div class="row sqs-row">
          <div class="col sqs-col-2 span-2">
            <div class="sqs-block html-block sqs-block-html" data-block-type="2">
              <div class="sqs-block-content">
                <div class="odometer-wrapper" style="padding-top:30px">
                  <div class="text-align-center odometer-value">
                    <span id="odometer-video-counted" class="odometer">0</span>
                  </div>
                  <p class="text-align-center odometer-label">Total Videos<br /> Counted</p>
                </div>
                <div class="odometer-wrapper" style="padding-top:10px">
                  <div class="text-align-center odometer-value">
                    <span id="odometer-video-remaining" class="odometer">0</span>
                  </div>
                  <p class="text-align-center odometer-label">Total Videos Remaining</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col sqs-col-7 span-7">
            <div class="sqs-block image-block sqs-block-image" data-block-type="5">
              <div class="sqs-block-content">
                <div id="chart-video"></div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import * as d3Time from 'd3-time'
import * as d3TimeFormat from 'd3-time-format'
import Odometer from 'odometer'
import jstat from 'jstat'
import { mapGetters } from 'vuex'
import highcharts from 'highcharts'

const colors = highcharts.getOptions().colors

export default {
  data () {
    return {
      selectedVariable: 'temperature_degc',
      variables: [
        {
          id: 'temperature_degc',
          label: 'Water Temperature',
          labelUnits: 'Water Temperature (degC)'
        },
        {
          id: 'specificconductance_us_cm',
          label: 'Specific Conductivity',
          labelUnits: 'Specific Conductivity (uS/cm)'
        },
        {
          id: 'turbidity_ntu',
          label: 'Turbidity',
          labelUnits: 'Turbidity (NTU)'
        },
        {
          id: 'odo_mg_l',
          label: 'Dissolved Oxygen',
          labelUnits: 'Dissolved Oxygen (mg/L)'
        },
        {
          id: 'chlorophyll_rfu',
          label: 'Chlorophyll',
          labelUnits: 'Chlorophyll (RFU)'
        }
      ],
      data: {
        activity: {
          total: 0,
          values: []
        },
        run: {
          total: {
            y: 0,
            range: 0
          },
          values: []
        },
        sensor: [],
        fish: {
          total: 0,
          values: []
        },
        video: {
          total: {
            counted: 0,
            remaining: 0
          },
          values: []
        }
      },
      charts: {
        activity: null,
        run: null,
        sensor: null,
        fish: null,
        video: null
      },
      odometers: {
        activity: null,
        run: {
          total: null,
          range: null
        },
        fish: null,
        video: {
          counted: null,
          remaining: null
        }
      }
    }
  },
  computed: {
    ...mapGetters(['locationId', 'videoYear', 'session'])
  },
  watch: {
    selectedVariable () {
      this.updateSensor()
    },
    'session.count' () {
      this.onCount()
    }
  },
  mounted () {
    let today = d3Time.timeDay.floor(new Date())
    if (today.getUTCHours() < 4) {
      today = new Date(today.getTime() - (86400 * 1000))
    }
    const tomorrow = new Date(today.getTime() + (86400 * 1000))

    this.odometers.activity = new Odometer({
      el: document.getElementById('odometer-activity-total'),
      value: 0
    })
    this.odometers.run.total = new Odometer({
      el: document.getElementById('odometer-run-total'),
      value: 0
    })
    this.odometers.run.range = new Odometer({
      el: document.getElementById('odometer-run-range'),
      value: 0
    })
    this.odometers.fish = new Odometer({
      el: document.getElementById('odometer-fish-total'),
      value: 0
    })
    this.odometers.video.counted = new Odometer({
      el: document.getElementById('odometer-video-counted'),
      value: 0
    })
    this.odometers.video.remaining = new Odometer({
      el: document.getElementById('odometer-video-remaining'),
      value: 0
    })

    this.charts.activity = this.$highcharts.chart('chart-activity', {
      chart: {
        type: 'bubble',
        height: 150,
        marginLeft: 75,
        zoomType: 'x'
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%b %d',
          day: '%b %d'
        },
        title: {
          text: 'Time'
        },
        min: today.valueOf(),
        max: tomorrow.valueOf()
      },
      yAxis: {
        visible: false
      },
      plotOptions: {
        bubble: {
          marker: {
            fillOpacity: 0.1
          },
          minSize: 2,
          maxSize: 50
        }
      },
      legend: {
        enabled: false
      },
      tooltip: {
        useHTML: true,
        headerFormat: '<table>',
        pointFormat: '<tr><th style="text-align:right"># Fish Counted:</th><td style="padding-left:10px">{point.z}</td></tr>' +
          '<tr><th style="text-align:right">Counted At:</th><td style="padding-left:10px">{point.count_timestamp}</td></tr>' +
          '<tr><th style="text-align:right">Video Recorded At:</th><td style="padding-left:10px">{point.video_timestamp}</td></tr>' +
          '<tr><th style="text-align:right">Video Duration:</th><td style="padding-left:10px">{point.duration} sec</td></tr>',
        footerFormat: '</table>',
        followPointer: false,
        hideDelay: 250
      },
      series: [{
        name: 'Video Count',
        data: []
      }]
    })
    this.charts.run = this.$highcharts.chart('chart-run', {
      chart: {
        type: 'column',
        height: 275,
        marginLeft: 75
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%b %d',
          week: '%b %d',
          day: '%b %d'
        },
        title: {
          text: 'Date'
        }
        // min: this.dateRange[0].valueOf(),
        // max: this.dateRange[1].valueOf()
      },
      yAxis: {
        title: {
          text: 'Estimated # Fish per Day'
        }
      },
      plotOptions: {
        column: {
          groupPadding: 0,
          pointPadding: 0
        }
      },
      legend: {
        enabled: false
      },
      series: [
        {
          name: 'Estimated # Fish',
          data: [],
          type: 'column',
          tooltip: {
            valueDecimals: 0
          }
        }, {
          name: 'Uncertainty Range',
          data: [],
          type: 'errorbar',
          tooltip: {
            valueDecimals: 0
          }
        }
      ],
      tooltip: {
        shared: true
      }
    })
    // this.charts.sensor = this.$highcharts.chart('chart-sensor', {
    //   chart: {
    //     type: 'line',
    //     height: 275,
    //     marginLeft: 75,
    //     zoomType: 'x'
    //   },
    //   title: {
    //     text: ''
    //   },
    //   xAxis: {
    //     type: 'datetime',
    //     dateTimeLabelFormats: {
    //       month: '%b %d',
    //       week: '%b %d',
    //       day: '%b %d'
    //     },
    //     title: {
    //       text: 'Date'
    //     }
    //     // min: this.dateRange[0].valueOf(),
    //     // max: this.dateRange[1].valueOf()
    //   },
    //   yAxis: {
    //     title: {
    //       text: null
    //     },
    //     min: 0,
    //     endOnTick: false,
    //     tickPixelInterval: 36
    //   },
    //   plotOptions: {
    //   },
    //   legend: {
    //     enabled: false
    //   },
    //   series: []
    // })
    this.charts.fish = this.$highcharts.chart('chart-fish', {
      chart: {
        type: 'column',
        height: 275,
        marginLeft: 75
      },
      title: {
        text: ''
      },
      plotOptions: {
        column: {
          groupPadding: 0,
          pointPadding: 0,
          stacking: 'normal'
        }
      },
      legend: {
        enabled: false
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%b %d',
          week: '%b %d',
          day: '%b %d'
        },
        title: {
          text: 'Date'
        }
        // min: this.dateRange[0].valueOf(),
        // max: this.dateRange[1].valueOf()
      },
      yAxis: {
        min: 0,
        title: {
          text: '# Fish Counted per Day'
        }
      },
      series: [{
        name: '# Fish',
        data: []
      }]
    })
    this.charts.video = this.$highcharts.chart('chart-video', {
      chart: {
        type: 'column',
        height: 275,
        marginLeft: 75
      },
      title: {
        text: ''
      },
      plotOptions: {
        column: {
          groupPadding: 0,
          pointPadding: 0,
          stacking: 'normal'
        }
      },
      legend: {
      },
      tooltip: {
        shared: true
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
          month: '%b %d',
          week: '%b %d',
          day: '%b %d'
        },
        title: {
          text: 'Date'
        }
        // min: this.dateRange[0].valueOf(),
        // max: this.dateRange[1].valueOf()
      },
      yAxis: {
        min: 0,
        title: {
          text: '# Videos Recorded per Day'
        }
      },
      series: [
        {
          name: '# Counted',
          data: [],
          color: colors[3]
        },
        {
          name: '# Not Counted',
          data: []
        }
      ]
    })

    this.fetchStatusData()
      .then(this.updateStatus)
    this.fetchRunData()
      .then(this.updateRun)
    // this.fetchSensorData()
    //   .then(this.updateSensor)
  },
  methods: {
    onCount () {
      this.fetchStatusData()
        .then(this.updateStatus)
      this.fetchRunData()
        .then(this.updateRun)
    },
    fetchStatusData () {
      const utcFormat = d3TimeFormat.utcFormat('%b %d %I:%M %p EDT')
      const edtFormat = x => utcFormat(d3Time.timeHour.offset(x, -4))

      return this.$http.get('/status/', { params: { location_id: this.locationId } })
        .then((response) => {
          const data = response.data.data

          const dataActivity = data.activity.map(d => ({
            x: (new Date(d.count_timestamp)).valueOf(),
            y: 0,
            z: d.count,
            duration: Math.round(d.duration),
            video_timestamp: edtFormat(new Date(d.video_start)),
            count_timestamp: edtFormat(new Date(d.count_timestamp))
          }))
          const dataFish = data.fish.map(d => [
            d3Time.timeHour.offset(new Date(d.date), 4).valueOf(),
            Math.round(d.count)
          ])
          const dataVideo = data.video.map(d => ({
            date: d3Time.timeHour.offset(new Date(d.date), 4),
            n_remaining: d.n_total - d.n_counted,
            n_counted: d.n_counted
          }))

          this.data.activity.total = dataActivity.length
          this.data.activity.values = dataActivity
          this.data.fish.total = dataFish.reduce((p, v) => (p + v[1]), 0)
          this.data.fish.values = dataFish
          this.data.video.total.counted = dataVideo.reduce((p, v) => (p + v.n_counted), 0)
          this.data.video.total.remaining = dataVideo.reduce((p, v) => (p + v.n_remaining), 0)
          this.data.video.values = dataVideo
        })
    },
    fetchRunData () {
      return this.$http.get('/run-estimate/', { params: { location_id: this.locationId } })
        .then((response) => {
          const data = response.data.data

          this.data.run.values = data.map((d) => {
            let tStar = jstat.studentt.inv(0.975, d.df)
            if (isNaN(tStar)) {
              tStar = 0
            }
            return {
              x: (d3Time.timeHour.offset(new Date(d.date), 4)).valueOf(),
              y: Math.round(d.y),
              low: Math.max(Math.round(d.y) - (tStar * Math.sqrt(d.var_y)), 0),
              high: Math.round(d.y) + (tStar * Math.sqrt(d.var_y))
            }
          })

          const totalData = data.reduce((p, v) => {
            p.y += v.y
            p.var_y += v.var_y
            p.df_num += v.df_num
            p.df_den += v.df_den
            return p
          }, { y: 0, var_y: 0, df_num: 0, df_den: 0 })

          totalData.df = Math.round((totalData.df_num * totalData.df_num) / totalData.df_den)
          totalData.tStar = jstat.studentt.inv(0.975, totalData.df)
          totalData.ciRange = totalData.tStar * Math.sqrt(totalData.var_y)

          this.data.run.total = {
            y: Math.round(totalData.y),
            range: Math.round(totalData.ciRange)
          }
        })
    },
    fetchSensorData () {
      return this.$http.get('/sensor-hourly/', { params: { location_id: this.locationId } })
        .then((response) => {
          const data = response.data.data.map(d => ({
            timestamp: (new Date(d.datetime)),
            temperature_degc: d.temperature_degc,
            turbidity_ntu: d.turbidity_ntu,
            specificconductance_us_cm: d.specificconductance_us_cm,
            chlorophyll_rfu: d.chlorophyll_rfu,
            odo_mg_l: d.odo_mg_l
          }))
          this.data.sensor = data
        })
    },
    updateStatus () {
      // activity
      this.odometers.activity.update(this.data.activity.total)
      this.charts.activity.series[0].setData(this.data.activity.values)

      // fish counts
      this.odometers.fish.update(Math.round(this.data.fish.total))
      this.charts.fish.series[0].setData(this.data.fish.values)

      // video counts
      this.odometers.video.counted.update(this.data.video.total.counted)
      this.odometers.video.remaining.update(this.data.video.total.remaining)
      this.charts.video.series[0].setData(this.data.video.values.map(d => ({
        x: d.date.valueOf(),
        y: d.n_counted
      })), false)
      this.charts.video.series[1].setData(this.data.video.values.map(d => ({
        x: d.date.valueOf(),
        y: d.n_remaining
      })))
    },
    updateRun () {
      this.odometers.run.total.update(this.data.run.total.y)
      this.odometers.run.range.update(this.data.run.total.range)
      this.charts.run.series[0].setData(this.data.run.values.map(d => ({
        x: d.x,
        y: d.y
      })), false)
      this.charts.run.series[1].setData(this.data.run.values.map(d => ({
        x: d.x,
        low: d.low,
        high: d.high
      })))
      // this.charts.run.addSeries({
      //   name: 'Estimated # Fish',
      //   data: this.data.run.values.map(d => ({ x: d.x, y: d.y })),
      //   type: 'column',
      //   tooltip: {
      //     valueDecimals: 0
      //   }
      // }, false)
      // this.charts.run.addSeries({
      //   name: 'Uncertainty Range',
      //   data: this.data.run.values.map(d => ({ x: d.x, low: d.low, high: d.high })),
      //   type: 'errorbar',
      //   tooltip: {
      //     valueDecimals: 0
      //   }
      // }, true)
    },
    updateSensor () {
      const chart = this.charts.sensor
      const data = this.data.sensor
      const variableId = this.selectedVariable
      const variableLabel = this.variables.find(d => (d.id === variableId)).labelUnits

      if (chart.series.length > 0) {
        chart.series[0].remove()
      }

      if (variableId && data && data.length > 0) {
        // chart.title.update({ text: variableLabel });
        chart.yAxis[0].setTitle({ text: variableLabel })
        chart.addSeries({
          name: variableLabel,
          data: data.map(d => [d.timestamp.valueOf(), d[variableId]]),
          type: 'line',
          tooltip: {
            valueDecimals: 1
          }
        })
      }
    }
  }
}
</script>

<style scoped>
h1.count-title {
  font-size: 24px;
}
.small-text {
  font-size: 0.7em;
  line-height: 1.3;
  font-family: sans-serif;
  color: #888;
}
.select-label {
  text-align: right;
}
p.odometer-label {
  margin-top: 5px;
  font-size: 16px;
  line-height: 1.2;
}
.odometer-value {
  font-size: 32px;
}
.odometer-value-small {
  font-size: 16px;
}
.count-title-block {
  padding-bottom: 0;
}
.count-title {
  border-bottom: 1px solid #EEE;
}

</style>
